import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

const Dropdown = ({
    options = [],
    selectedId,
    value,
    onChange,
    displayKey = "label",
    className = ""
}) => {
    const [open, setOpen] = useState(false);

    const handleSelect = (option, index) => {
        onChange(option, index);
        setOpen(false);
    };

    return (
        <div className={`relative inline-block ${className} min-w-0`}>
            <button
                onClick={() => setOpen(!open)}
                className="px-4 py-2 w-full bg-gradient-to-r from-cyan-50 to-blue-50 border-2 border-cyan-200
                           rounded-full text-sm font-semibold text-gray-800 cursor-pointer flex items-center justify-between"
            >
                <span className="truncate max-w-[90px] block">{value}</span>
                <ChevronDown size={18} className={`transition ${open ? "rotate-180" : ""}`} />
            </button>

            {open && (
                <div className="absolute mt-2 min-w-full bg-white z-20 rounded-xl shadow-lg border max-h-60 overflow-y-auto">
                    {options.map((opt, idx) => {
                        const isSelected = opt.id === selectedId;

                        return (
                            <div
                                key={idx}
                                onClick={() => handleSelect(opt, idx)}
                                className={`px-4 py-2 cursor-pointer text-sm flex items-center gap-2 
                                    ${isSelected
                                        ? "bg-cyan-100 font-semibold"
                                        : "hover:bg-gray-100"
                                    }
                                `}
                            >
                                {opt[displayKey]}
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default Dropdown;
